require('./brokerStocksSaleOrderWizard.scss');

const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const BrokerStocksSaleOrderStep1 = require('./brokerStocksSaleOrderStep1/brokerStocksSaleOrderStep1');
const BrokerStocksSaleOrderStep2 = require('./brokerStocksSaleOrderStep2/brokerStocksSaleOrderStep2');

class BrokerStocksSaleOrderWizard extends React.Component {
    constructor(props) {
        super(props);

        this.handleValidation = this.handleValidation.bind(this);
        this.wizardWillCancel = this.wizardWillCancel.bind(this);
    }

    componentWillReceiveProps(newProps) {
        const { immBrokerStocksSaleOrder, immSignaturePattern, onFinish} = this.props;
        const fetchConfirmOrder = immBrokerStocksSaleOrder.get('fetchConfirmOrder');
        const showWarningSMS = immSignaturePattern.get('showWarningSMS');
        const newShowWarningSMS = newProps.immSignaturePattern.get('showWarningSMS');
        const errorState = showWarningSMS !== newShowWarningSMS && newShowWarningSMS;

        if(fetchConfirmOrder !== newProps.immBrokerStocksSaleOrder.get('fetchConfirmOrder') || errorState) {
            onFinish();
        }
    }

    handleValidation(step) {
        this.props.onValidateStep(step - 1);
    }

    wizardWillCancel() {
        this.props.history.goBack();
    }

    render() {
        const {
            immBrokerStocksSaleOrder,
            immCorporatesOperations,
            onChangeTitlesAmount,
            onSetVisibleStep,
            onChangeManifest,
            onFinish,
            setDocumentsRead
        } = this.props;
        const visibleStep = immBrokerStocksSaleOrder.get('visibleStep');
        const immSteps = immBrokerStocksSaleOrder.get('steps');
        const actions = {
            validateStep: this.handleValidation,
            setVisibleStep: onSetVisibleStep,
            setWillCancel: this.wizardWillCancel,
            finish: onFinish
        };

        return (
            <Wizard
                wizardClass="broker-stocks-sale-order-wizard"
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
            >
                <BrokerStocksSaleOrderStep1
                    immBrokerStocksSaleOrder={immBrokerStocksSaleOrder}
                    immCorporatesOperations={immCorporatesOperations}
                    actions={actions}
                    onChangeTitlesAmount={onChangeTitlesAmount}
                />
                <BrokerStocksSaleOrderStep2
                    immBrokerStocksSaleOrder={immBrokerStocksSaleOrder}
                    actions={actions}
                    onChangeManifest={onChangeManifest}
                    setDocumentsRead={setDocumentsRead}
                />
            </Wizard>
        );
    }
}

BrokerStocksSaleOrderWizard.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerStocksSaleOrder: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    onChangeTitlesAmount: PropTypes.func.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onSetVisibleStep: PropTypes.func.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired
};

module.exports = withRouter(BrokerStocksSaleOrderWizard);
